export default __webpack_public_path__ + "content/media/vive109.714d6823.pdf";